<form
    [class]="isMobile()?'h-full w-screen':'w-[90vw] max-h-[85vh] md:min-w-[60vw] lg:w-[40vw] max-w-7xl md:max-h-[90vh]'"
    class="bg-lightCardBG dark:bg-darkCardBG m-auto">
    <div
        class="w-full py-3 px-5 flex items-center justify-between border-b border-lightMode-300 dark:border-darkMode-700">
        <p
            class="text-lightMode-800 dark:text-darkMode-100 text-lg md:text-xl font-bold">
            {{getData.action=='add'? 'افزودن مهارت زبان' : 'ویرایش مهارت زبان'}}
        </p>
        <button matRipple (click)="closePostState($event)"
            [class]="isMobile()?'w-10 h-10':'w-12 h-12'"
            class=" flex items-center justify-center rounded-full hover:bg-[#8080802a] ease-in-out duration-100">
            <mat-icon aria-hidden="true" data-mat-icon-type="font"
                class="mat-center text-lightMode-800 dark:text-darkMode-100 tools-icon "
                [class]="isMobile()?'text-2xl':'text-3xl'">
                close
            </mat-icon>
        </button>
    </div>
    <div id="search-select-parent"
        [class]="isMobile()?'max-h-[calc(100vh-135px)]':'max-h-[60vh]'"
        class="w-full py-3 px-[5%] overflow-y-scroll scrollbar-hidden flex-col items-center justify-center text-lightMode-800 dark:text-darkMode-100">
        <div class="w-full my-3">
            <app-search-select [config]="{rounded: true,roundedFull: true}"
                [isCheck]="isSubmited" [type]="'language'"
                [initSelectItem]="data.language_id"
                (emitId)="updateLanguage($event)"></app-search-select>
        </div>
        <div class="grid grid-cols-2 gap-3 md:min-w-[490px]">
            <div *ngFor="let i of [0,1,2,3]"
                class="col-span-2 sm:col-span-1 flex-shrink-0 overflow-hidden flex flex-col items-start justify-start">
                <p class="rtl:ml-2 ltr:mr-2 mb-2">
                    {{i==0?'مهارت خواندن :':''}} {{i==1?'مهارت نوشتن :':''}}
                    {{i==2?'مهارت شنیداری :':''}} {{i==3?'مهارت گفتاری :':''}}
                </p>
                <app-rating [rating]="sendRate(getData,i)"
                    [ratingArr]="[1,2,3,4,5,6,7,8,9,10]"
                    (ratingUpdated)="readingSkillUpdate($event,i)"></app-rating>
            </div>
        </div>
        <div class="mt-8 w-full flex justify-end items-center">
            <app-slide-toggle-button
                [status]="data.is_public==null?true:data.is_public"
                [label]="'به کاربران دیگر نمایش داده شود'"
                [config]="{direction: 'rtl'}"
                (statusEmitter)="updataIsPublic($event)"
                class="mr-2"></app-slide-toggle-button>
        </div>
    </div>
    <div [class]="isMobile()?'absolute':''"
        class="flex flex-row-reverse py-3 px-5 border-t border-lightMode-300 dark:border-darkMode-700 w-full bg-lightCardBG
    dark:bg-darkCardBG">
        <button [disabled]="modalService.waiting" matRipple
            (click)="formSubmit($event)" type="submit"
            class="activeBG py-1 px-8 h-[36px] w-full md:w-auto text-white text-lg rounded-full">
            <div *ngIf="modalService.waiting;else edit"
                class="lds-ring"><div></div><div></div><div></div><div></div></div>
            <ng-template #edit>ثبت</ng-template>
        </button>
    </div>
</form>